var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-counter col-md-4"},[_c('h4',[_c('span',{staticClass:"counter"},[_vm._v(_vm._s(_vm.count))])]),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }